export const STATUS = {
    PENDING:'pending',
    READY:'Ready',
    ERROR:'error',
    FILTERING:'filtering'
}

